import { secondAxios } from "../../../../../../api/axios";


export const get5d = async (equipId) => {
    const response = await secondAxios.get(`/cost5d/${equipId}`);
    console.log({ response });
    return response.data;
}